import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Group/';

const getAllGroups = async (isActive) => axiosInstance.get(`${ENDPOINTORIGIN}GetAllGroups?isActive=${isActive}`, constants.REQUIRE_INTERCEPTORS);

const getAllGroupOptions = async () => axiosInstance.get(`${ENDPOINTORIGIN}GetAllGroupOptions`, constants.REQUIRE_INTERCEPTORS);

const getGroupById = async (groupId) => axiosInstance.get(`${ENDPOINTORIGIN}GetGroupById?groupId=${groupId}`, constants.REQUIRE_INTERCEPTORS);

const createGroup = async (group) => axiosInstance.post(`${ENDPOINTORIGIN}CreateGroup`, group, constants.REQUIRE_INTERCEPTORS);

const updateGroup = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateGroup`, model, constants.REQUIRE_INTERCEPTORS);

const deleteGroup = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteGroup?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getAllGroups,
  getAllGroupOptions,
  getGroupById,
  createGroup,
  updateGroup,
  deleteGroup,
};